import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {SidebarRightComponent} from "@webmate-web-core/shared/components/sidebarright/sidebarright.component";
import {UserNotificationAreaComponent} from "@webmate-web-core/shared/components/sidebarright/usernotificationarea.component";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {ButtonModule} from "primeng/button";
import {EditorModule} from "primeng/editor";
import {InputTextModule} from "primeng/inputtext";
import {AvatarModule} from "@webmate-web-core/shared/components/avatar/avatar.module";
import {FormsModule} from '@angular/forms';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {CheckboxModule} from "primeng/checkbox";
import {
    DisplayNotificationComponent
} from "@webmate-web-core/shared/components/notification/display-notification.component";

@NgModule({
    declarations: [
        SidebarRightComponent,
        UserNotificationAreaComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        FontAwesomeModule,
        ButtonModule,
        InputTextModule,
        AvatarModule,
        ProgressSpinnerModule,
        CheckboxModule,
        DisplayNotificationComponent
    ],
    exports: [
        SidebarRightComponent,
        UserNotificationAreaComponent
    ]
})
export class SidebarRightModule { }
